<template>
	<div id="measurement-schedule-list">
		<div v-if="schedules != null" class="list cell-schedule-card py-3 px-4">
			<div class="big-icon-container">
				<doctor-woman-icon width="50px"></doctor-woman-icon>
			</div>
			<div class="created-at px-3 has-text-left is-size-6">
                {{ isDoctor
                ? ""
                : "Recuerda tomar las mediciones a la hora recomendada"
                }}
				<br> Actualizado el:
				{{ createdAt }}
			</div>
			<div class="px-3 has-text-left">
				<span class="tag is-bg-primary mx-1 is-size-6" v-for="(sch, i) in items" :key="'sch' + i">
					<span>{{ sch[0] }}</span>
					<span>:</span>
					<span>{{ sch[1] }}</span>
				</span>
			</div>
		</div>
		<div v-else class="empty">
			<article class="message is-danger">
				<div class="message-body">
					Paciente no tiene rutina para toma de medición
				</div>
			</article>
		</div>
	</div>
</template>

<script lang="ts">
	import {
		formatDateTime,
		MeasurementSchedule,
		RoutineMeasurement,
	} from "@/domain/entities/EntityFields";
	import { computed, defineComponent, PropType } from "vue";
	import DoctorWomanIcon from "@/assets/DoctorWomanIcon.vue";

	export default defineComponent({
		components: {
			DoctorWomanIcon,
		},
		props: {
			schedules: {
				type: Object as PropType<MeasurementSchedule>,
				default: () => null,
            },
            isDoctor: {
                type: Boolean,
                value: false
            }
		},
		setup(props) {
			let items = computed(() => {
				return (
					props?.schedules?.routine?.map((e: RoutineMeasurement) =>
						e.takeMeasureTime.split(":")
					) || []
				);
			});
			
			let createdAt = computed(() => {
				if (props.schedules == null) return ''
				if (props.schedules.createdAt.toDate != undefined) {
					return formatDateTime(props.schedules.createdAt.toDate())
				}
				return ''
			})
			return {
				items,
				createdAt,
				// formatDateTime,
			};
		},
	});
</script>

<style lang="stylus" scoped>
	@import '../styles/elements.styl';

	.cell-schedule-card {
		@extend .cell-shiny-primary-alt;
		display: grid;
		// background #ff577f
		grid-template-columns: 50px auto;
		grid-template-rows: auto auto;
	}

	.created-at {
		align-self: center;
	}

	.cell-schedule-card > .big-icon-container {
		grid-row: span 2;
	}
</style>
